import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/index.scss";

ReactDOM.createRoot(
  document.getElementById("root")
).render(

  <BrowserRouter>
    <App />
  </BrowserRouter>

);